import styled from 'styled-components';
import { MAX_WRAPPER_SIZE } from '../../../../settings';

export default {
    FooterContainer: styled.div.attrs({ className: 'footer-container' })`
        width: 100vw;
        height: 209px;
        background: #E4E4E4;
        @media (min-width: 900px) {
            height: 250px;
        }
    `,
    FooterWrapper: styled.div.attrs({ className: 'footer-wrapper' })`
        max-width: ${MAX_WRAPPER_SIZE};
        min-width: 320px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding-left: 8px;
        padding-right: 8px;
        flex-wrap: wrap;
        box-sizing: border-box;
        @media (min-width: 600px) {
            justify-content: space-between;
            align-items: flex-start;
            padding-top: 73px;
            height: auto;
        }
        @media (min-width: 1220px) {
            padding-left: 8px;
            padding-right: 8px;
        }
    `,
    FooterPart: styled.div.attrs({ className: 'footer-part' })`
        display: flex;
        flex-direction: column;
        align-items: self-start;
        width: 100%;
        @media (min-width: 600px) {
            width: initial;
        }
    `,
    FooterBigText: styled.span`
        font-family: 'Toyota Display Bold';
        font-size: 24px;
        font-weight: bold;
        line-height: 36px;
        color: #202020;
        padding-left: 8px;
        letter-spacing: 0.25px;
        @media (min-width: 900px) {
            margin-bottom: 9px;
            padding-left: 0;
            font-size: 18px;
        }
    `,
    FooterText: styled.span`
        font-family: Toyota Display;
        font-size: 12px;
        line-height: 24px;
        padding-left: 8px;
        color: #595D60;
        @media (min-width: 900px) {
            line-height: 30px;
            padding-left: 0;
            font-size: 16px;
            margin-bottom: 10px;
        }
    `,
    RedLink: styled.a.attrs({ className: 'red-link' })`
        color: #E50000;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    `,
    RedLinkUnderlined: styled.a.attrs({ className: 'red-link-underlined' })`
        color: #E50000;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    `,
};
